import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles.css';

const root = document.getElementById('root');
if (!root) throw new Error('A raiz da aplicação não foi encontrada');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>
);

if ('serviceWorker' in navigator && import.meta.env.PROD)
  window.addEventListener('load', () => void navigator.serviceWorker.register('/sw.js'));
